import { useFormContext } from 'react-hook-form'
import Textarea from '@components/form/Textarea'
import Error from '@components/form/validation/Error'
import useT from '@hooks/useTranslation'

const ContextTextarea = ({ t, error, ...rest }) => {
    const { register } = useFormContext()
    const label = useT(t || rest.name)
    return <>
        <Textarea {...rest}
            register={register}
            label={label} />

        { error && <Error name={rest.name} /> }
    </>
}

export default ContextTextarea